$(function() {

	// check if browser supports background size
	if('backgroundSize' in document.documentElement.style) {
		$('html').addClass('supports-bgsize');
	}

	// Account Dropdown
	$('.js-account-dropdown').on('click', function(e) {
		e.preventDefault()
		const $parent = $(this).parent();
		const isMobile = matchMedia("screen and (max-width: 767px)").matches

		if(isMobile) return

		if( !$parent.hasClass('selected')) {
			hide_dds();
			$parent.addClass('selected');
		}else {
			$parent.removeClass('selected');
		}
		return false;
	});

	// Dropdown
	$('.dd-link').parent().click(function(){
		var dd = $(this).parent().find('.dd');

		if( !$(this).hasClass('selected') ) {
			hide_dds();
			$(this).addClass('selected');
			dd.show();
		}else {
			$(this).removeClass('selected');
			dd.hide();
		}
		return false;
	});

	var $body = $('body');

	$('.navigation-trigger')
		.click(function(event) {
			event.preventDefault();

			$body.toggleClass('navigation-open').removeClass('navigation-right-open').removeClass('sidebar-open');
		});

	$('.navigation-right-trigger')
		.click(function(event) {
			event.preventDefault();

			$body.toggleClass('navigation-right-open').removeClass('navigation-open sidebar-open');
		});

	$('.navigation-overlay')
		.click(function() {
			$body.removeClass('navigation-open navigation-right-open sidebar-open');
		});

	$('.sub-nav-inner .active')
		.click(function(event) {
			if ($(window).width() >= 768) {
				return;
			}

			var $link = $(this);
			var $subnav = $('#sub-nav');

			if($link.index() > 0) {
				$subnav.find('.sub-nav-drop').prepend($link);
			}

			event.preventDefault();

			$subnav.toggleClass('sub-nav-open');
		});

	$('.js-toggle-filters').click(function(event) {
		$body.toggleClass('filters-open')
	})

	$body
		.click(function(event) {
			var $target = $(event.target);

			if(!$target.parents('#sub-nav').length && $('#sub-nav').hasClass('sub-nav-open')) {
				$('#sub-nav').removeClass('sub-nav-open');
			}
		});

	var $search = $('#search');

	$search.find('.field')
		.focus(function() {
			$search.addClass('search-open');
			this.selectionStart = this.selectionEnd = 10000;
		})
		.blur(function() {
			setTimeout(function() {
				$search.removeClass('search-open');
			}, 500);
		});

	var $sidebarTrigger = $('.sidebar-trigger');

	$sidebarTrigger
		.click(function(event) {
			event.preventDefault();

			$body.toggleClass('sidebar-open').removeClass('navigation-open navigation-right-open');
		});

	var $clientSidebar = $('#sidebar.client-layout');

	if($clientSidebar.length > 0) {
		var $accordionHeadings = $('#admins-sidebar-box .sidebar-box-head h3, #co-workers-sidebar-box .sidebar-box-head h3');

		$accordionHeadings
			.click(function() {
				$(this).closest('.sidebar-box').toggleClass('expanded');
			})
			.trigger('click');
	}

	var $projectDetailsToggle = $('.project-details').find('.project-details__head');

	$projectDetailsToggle
		.click(function() {
			$(this).parent().toggleClass('expanded');
		});

	// Hide Dropdown
	function hide_dds(){
		$('.js-account-dropdown').parent().removeClass('selected')
		$('.dd').hide();
		$('.dd').each(function(){
			$(this).parent().find('a.selected').eq(0).removeClass('selected');
		});
	}
	$(document).click(hide_dds);

	var $win = $(window);
	var $projectsList = $('.projects:not(.selectable)');
	var $projectsItems = $projectsList.find('tr');
	var $projectChecks = $projectsList.find('input.c');

	$win.resize(function() {
		if($win.width() >= 768) {
			$body.removeClass('checkbox-mode');
		}
	})

	$projectsItems
		.click(function(event) {
			var $target = $(event.target);
			if($win.width() < 768 && $body.hasClass('checkbox-mode') && !$target.hasClass('c')) {
				var $projectItem = $(this);
				var $check = $projectItem.find('input.c');

				$check.prop('checked', !$check.is(':checked')).trigger('change');

				return false;
			}
		});

	if($projectChecks.length > 0) {
		$projectChecks
			.change(function() {
				var $checked = $projectsList.find('input.c:checked');

				$body.toggleClass('checkbox-mode', $checked.length > 0);
			});
	}

	var $buttonCancel = $('input.button-cancel');

	$buttonCancel
		.click(function(event) {
			event.preventDefault();

			var $checked = $projectsList.find('input.c:checked');

			$checked.each(function() {
				$(this).prop('checked', false).trigger('change');
			});
		});


	// Blink fields
	$('body')
	.on('focusin', '.blink', function(){
		if($(this).val() == $(this).attr('title')) { $(this).val(''); }
	})
	.on('focusout', '.blink', function(){
		if($(this).val() == '') { $(this).val($(this).attr('title'));  }
	});


	// Confirm
	$('body').on('click', '*[confirm]', function() {
		return confirm($(this).attr('confirm'));
	});

	// Update fixed position when related tasks widget gets updated.
	if (window.$eventDispatcher) {
		window.$eventDispatcher.$on('relatedTasks:updated', function() {
			$(window).trigger('scroll');
		});
	}

	// Change the layout of project details when the window is resized
	function fix_project_details(){
		if( $('.comment-project-details').length == 0 ) return;

		if( $(window).width() < 1100 ) {
			$('.comment-project-details span').css('display', 'block');
			$('.comment-project-details p').addClass('block');
		}else {
			$('.comment-project-details span').css('display', 'inline');
			$('.comment-project-details p').removeClass('block');
		}
	}
	fix_project_details();
	$(window).resize(fix_project_details);


	// More/less info in table
	// Hide the more info
	$('table .show-more').each(function(){ $(this).parent().find('.long').addClass('hidden'); });

	$('table .show-more').click(function(){
		var td = $(this).parent();
		var long_info = td.find('.long');
		var short_info = td.find('.short');

		if( long_info.hasClass('hidden') ) {
			long_info.removeClass('hidden');
			short_info.addClass('hidden');
			td.css('white-space', 'normal');
			$(this).html('&laquo; less');
		}else {
			long_info.addClass('hidden');
			short_info.removeClass('hidden');
			td.css('white-space', 'nowrap');
			$(this).html('more &raquo;');
		}
		return false;
	});


	// Thank you message
	$('body').on('click', '.message a.close', function(){
		$(this).parents('.message').fadeOut();
		return false;
	});

	// Checkbox - Select all
	$('body').on('change', 'input.select-all', function(){
		var checks = $('.projects input[type=checkbox]');
		var checked = $(this).is(':checked');
		if( checked ) {
			checks.attr('checked', 1)
			checks.parent().parent().addClass('selected');
		}else {
			checks.removeAttr('checked');
			checks.parent().parent().removeClass('selected');
		}
		// trigger other JS binds to "change" event.
		$(checks).change();
	});


	// Checkbox - select single
	$('body').on('change', '.projects table input[type=checkbox]', function(){
		var tr = $(this).closest('tr');

		var checked = $(this).is(':checked');
		if( checked ) {
			tr.addClass('selected');
		}else {
			tr.removeClass('selected');
		}
		$('input.select-all').attr('checked', $('.projects input[type=checkbox]').length == $('.projects input[type=checkbox]:checked').length);
	});


	// Checkbox - select from tr
	$('body').on('click', '.selectable table tr', function(e){
		if( $(this).parents('.paid-charges').length ) return;

		if (!$(e.target).is('tr') && !$(e.target).is('td'))
			return;
		var check = $(this).find('input[type=checkbox]:first');
		if (check.is(':checked')) {
			check.attr('checked', false);
		} else {
			check.attr('checked', true);
		}

		check.change();
	});

	// dismiss page message
	$('div.message .dismiss').click(function() {
		var self = this;

		$(self).closest("div.message").slideUp();

		$.ajax({
			url: $(self).attr('href'),
			error: function() {
				alert("Error occured. Please try again later.");
			}
		});

		return false;
	});

	// fixing eip hover
	$('body')
		.on('mouseover', '.eip', function(){ if($(this).find('form').length > 0) return; $(this).addClass('eip-hover'); })
		.on('mouseout', '.eip', function(){ $(this).removeClass('eip-hover'); })
		.on('dblclick', '.eip', function(){ $(this).removeClass('eip-hover'); });

	// local client time
	$('body').on('click', '.local-time', function(){ $(this).find('span').toggle(); return false; });

	// disable the buttons when sending ajax bind some events to the form
	$('form')
		.bind('pre_ajax_request', function() {
			$(this).find('input[type=submit]').attr('disabled', true).addClass('disabled');
		})
		.bind('ajax_request_completed', function() {
			$(this).find('input[type=submit]').attr('disabled', false).removeClass('disabled');
		});

	// quotes links in projects
	$('.sidebar-box-quotes .list-quotes a').click(function(){
		console.log(  );
		var comment_id = $( this ).attr( 'href' );
		var $comment = $( comment_id );

		$comment.removeClass( 'collapsed-comment' );
	});


	// Signature Preview
	var $signature_holder = $( '.signature-outer' );
	var $input_signature = $( '[name="email_signature"]' );

	function toggle_signature_holder() {
		if( $input_signature.filter(':checked').val() == 'enable' ) {
			$signature_holder.show();

			return;
		}

		$signature_holder.hide();
	}

	$input_signature.change( toggle_signature_holder );
	toggle_signature_holder();

	// Expandable sections
	$('body').on('click', '.button-expand', function(e) {
		e.preventDefault();

		var $button = $(this);
		var $target = $($button.data('target'));
		var isExpanded = $target.hasClass('is-expanded');

		$target.toggleClass('is-expanded', !isExpanded);
		$button.text(!isExpanded ? $button.data('expanded') : $button.data('collapsed'));
	});



	// tooltip
	/*
	if( $('.tip').length > 0 ) {

		var tooltip = $('<div class="tooltip" />').appendTo('body');
		var tip_interval;

		$('.tip').hover(
			function(){
				window.clearInterval( tip_interval );

				var t = $(this).offset().top - 28;
				var l = $(this).offset().left - 6;
				var text = $(this).attr('title');
				//$(this).attr('title', '');

				tooltip.css('top', t).css('left', l).text( text ).show();
			},
			function(){
				window.clearInterval( tip_interval );
				tip_interval = window.setTimeout(function(){
					remove_tip();
				}, 100)
			}
		);

		tooltip.hover(
			function(){
				window.clearInterval( tip_interval );
			},
			function(){
				window.clearInterval( tip_interval );
				tip_interval = window.setTimeout(function(){
					remove_tip();
				}, 100)
			}
		);

		function remove_tip(){
			tooltip.hide();
		}
	}
	*/
});

// Simple JavaScript Templating
// John Resig - http://ejohn.org/ - MIT Licensed
(function(that){
  var cache = {};

  that.tmpl = function tmpl(str, data){
    // Figure out if we're getting a template, or if we need to
    // load the template - and be sure to cache the result.
    var fn = !/\W/.test(str) ?
      cache[str] = cache[str] ||
        tmpl(document.getElementById(str).innerHTML) :

      // Generate a reusable function that will serve as a template
      // generator (and which will be cached).
      new Function("obj",
        "var p=[],print=function(){p.push.apply(p,arguments);};" +

        // Introduce the data as local variables using with(){}
        "with(obj){p.push('" +

        // Convert the template into pure JavaScript
        str
          .replace(/[\r\t\n]/g, " ")
          .split("<%").join("\t")
          .replace(/((^|%>)[^\t]*)'/g, "$1\r")
          .replace(/\t=(.*?)%>/g, "',$1,'")
          .split("\t").join("');")
          .split("%>").join("p.push('")
          .split("\r").join("\\'")
      + "');}return p.join('');");

    // Provide some basic currying to the user
    return data ? fn( data ) : fn;
  };
})(window);


(function() {
	lightbox.option({
		'fadeDuration': 200,
		'resizeDuration': 200,
		'wrapAround': true
	});
})();
